export default "__VITE_ASSET__CgOSbh73__"